import {
    CREATE_CUTTING_PROGRAM_REMARKS_DATA, CREATE_USER_FORM_CUTTING_PROGRAM, FETCH_CUTTING_CONSOLIDATED_REPORT_SUCCESS, FETCH_CUTTING_PROGRAM_SUCCESS, NAVIGATE_CUTTING_DEFAULT, NAVIGATE_CUTTING_PROGRAM_DETAILS, NAVIGATE_CUTTING_INWARD_DETAILS,
    FETCH_CUTTING_INWARD_SUCCESS,
    FETCH_SALES_ORDER_BY_STYLE_SUCCESS
} from "./cuttingProgram.actionsType";

export const CUTTING_PROGRAM = 'cuttingProgram';

let initialState = {
    userform: { fldStartDateHeader: new Date(new Date().setDate(new Date().getDate() - 15)), fldEndDateHeader: new Date(), fldFkStyle: '' },
    isCuttingProgram: 'cuttingProgram',
    cuttingConsolidatedReport: [],
    SaleOrderByStyle: [],
};


export let cuttingProgramReducer = (state = initialState, action) => {
    let { type, payload, updatePayload, salesOrderId = {}, fldId } = action;

    switch (type) {
        case CREATE_USER_FORM_CUTTING_PROGRAM:
            return {
                ...state,
                loading: false,
                userform: {
                    ...state.userform,
                    [payload.key]: payload.value
                }
            };

        case NAVIGATE_CUTTING_PROGRAM_DETAILS: {
            return {
                ...state,
                isCuttingProgram: 'cuttingProgramDetail',
                // singleSalesOrderData: updatePayload.singleSalesOrder

            };
        }
        case NAVIGATE_CUTTING_INWARD_DETAILS: {
            return {
                ...state,
                isCuttingProgram: 'cuttingInwardDetail',
                // singleSalesOrderData: updatePayload.singleSalesOrder

            };
        }

        case NAVIGATE_CUTTING_DEFAULT: {
            return {
                ...state,
                isCuttingProgram: 'cuttingProgram',
            }


        }

        case FETCH_CUTTING_PROGRAM_SUCCESS: {
            return {
                ...state,
                cuttingProgramDetail: updatePayload

            }
        }
        case FETCH_CUTTING_INWARD_SUCCESS: {
            return {
                ...state,
                cuttingInwardDetail: updatePayload

            }
        }

        case FETCH_CUTTING_CONSOLIDATED_REPORT_SUCCESS: {
            return {
                ...state,
                cuttingConsolidatedReport: updatePayload

            }
        }

        case CREATE_CUTTING_PROGRAM_REMARKS_DATA:
            return {
                ...state,
                loading: false,
                // cuttingReportsData: payload,
                cuttingConsolidatedReport: payload,
            }

        case FETCH_SALES_ORDER_BY_STYLE_SUCCESS: {
            return {
                ...state,
                SaleOrderByStyle: updatePayload

            }
        }

        default:
            return state;
    }
};